import { detectPlatform, type NavigatorLike } from './platform';

/** The part of the Network Information API this reads (Chromium only; Safari and Firefox have none). */
interface ConnectionLike {
  readonly type?: string;
  readonly saveData?: boolean;
}

export interface DataNavigator extends NavigatorLike {
  readonly connection?: ConnectionLike;
}

/** Connections that don't count against a data plan. */
const UNMETERED = new Set(['wifi', 'ethernet']);

/**
 * Whether a large download now could cost the person money (mobile data).
 * The browser's word wins: data saver on or a cellular connection says yes,
 * Wi-Fi or a cable says no. Where it can't tell (every iPhone, most desktop
 * browsers), a phone or tablet is taken to be on mobile data and a computer
 * is not: asking once too often is cheaper than an unasked 300 MB bill.
 */
export function mayBeMetered(nav: DataNavigator | undefined = globalThis.navigator as DataNavigator | undefined): boolean {
  if (!nav) return false;
  const { connection } = nav;
  if (connection?.saveData || connection?.type === 'cellular') return true;
  if (connection?.type && UNMETERED.has(connection.type)) return false;
  return detectPlatform(nav) !== 'desktop';
}
